/*
 * @author Adrian Nitu <adrian.nitu at gmail.com>
 * @version 0.1 - 2017-06-08
 */

function CaravanaPOI (){
	var _this = this; //get 'this' object for private access
	var viewport, filters;
	var map, markers, markerManager, selected;

	this.reset = function(){
		if(typeof google != 'undefined' && $('#map_canvas').length)
			google.maps.event.addDomListener(window, 'load', this.init);
	};

	this.init = function(){
/*		pin = {
			icon: new google.maps.MarkerImage("/themes/bergenbier/img/caravana/pin-active.png",
					new google.maps.Size(34, 43), //dims
					new google.maps.Point(0, 0), //origin
					new google.maps.Point(11, 30) //anchor
				),
			shadow: new google.maps.MarkerImage("/../img/pin_shadow.png",
						new google.maps.Size(50, 11), //dims
						new google.maps.Point(0, 0), //origin
						new google.maps.Point(25, 6) //anchor
					)
			};*/
		var mapOptions = {
			zoom: 8, minZoom: 6,
			center: new google.maps.LatLng(45.9, 25),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true,
			fullscreenControl: true,
			zoomControl: true,
			scrollwheel: false,
			styles:
				[
					{
						"stylers": [
							{
								"hue": "#2c3e50"
							},
							{
								"saturation": 250
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "geometry",
						"stylers": [
							{
								"lightness": 50
							},
							{
								"visibility": "simplified"
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "labels",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					}
				]
		};

		map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);
		_this.map = map; //public exposure

		markers = [];
		$(".pin-content > div").each(function(){
			var data = {
				location: $(this).data('location'),
				content: this,
				image: "/themes/bergenbier/img/caravana/" + $(this).data('img')
			};
//			console.log(data);
			markers.push( createMarker(data) );
		});

		$(".caravana-locations").on('click', 'li', function(){
			google.maps.event.trigger($(this).data('marker'), 'click');
			if (window.matchMedia("(max-width: 767px)").matches) {
				scrollTo('#map_canvas',-50);
			}
		});

	};

	function createMarker(mark) {
		var marker = new google.maps.Marker({
			position: new google.maps.LatLng(mark.location.lat, mark.location.lng),
			map: map,
			animation: google.maps.Animation.DROP,
//			shadow: pin.shadow,
			icon: createPin(mark.image),
//			shape: pin_shape,
			title: mark.name
	//		zIndex: location[3]
		});
		marker.data = mark;
		createInfobox(marker);
		google.maps.event.addListener(marker, "click", selectMarker);
		return marker;
	}

	function createPin(image){
		return new google.maps.MarkerImage(image,
					new google.maps.Size(34, 44), //dims
					new google.maps.Point(0, 0), //origin
					new google.maps.Point(17, 44) //anchor
				)
	}

	function createInfobox(pin){
		var box = $(pin.data.content);
					//$(".box-template").clone().find('.content').html(pin.data.content).get(0)

		if (window.matchMedia("(max-width: 767px)").matches) {
			var options = {
				content: box.get(0),
				disableAutoPan: false,
				alignBottom: true,
				maxWidth: 300,
				pixelOffset: new google.maps.Size(-148, -50),
				//zIndex: null,
		//				, boxStyle: {
		//			background: "url("box_pointer.png') no-repeat"
		//					, opacity: 0.8
		//					, width: "280px"
		//		}
				closeBoxURL: "/themes/bergenbier/img/caravana/close.png",
				closeBoxMargin: "0 0 0 0",
	//			infoBoxClearance: new google.maps.Size(3, 3),
	//			isHidden: false,
	//			pane: "floatPane",
	//			enableEventPropagation: false
			};
		} else {
			var options = {
				content: box.get(0),
				//disableAutoPan: mapPan,
				alignBottom: true,
				maxWidth: 470,
				pixelOffset: new google.maps.Size(-235, -70),
				//zIndex: null,
		//				, boxStyle: {
		//			background: "url("box_pointer.png') no-repeat"
		//					, opacity: 0.8
		//					, width: "280px"
		//		}
				closeBoxURL: "/themes/bergenbier/img/caravana/close.png",
				closeBoxMargin: "0 -40px 0 0",
	//			infoBoxClearance: new google.maps.Size(3, 3),
	//			isHidden: false,
	//			pane: "floatPane",
	//			enableEventPropagation: false
			};
		}

		pin.infobox = new InfoBox(options);
		google.maps.event.addListener(pin.infobox, "closeclick", function(e) {
			if(selected.notClustered)
				markerManager.addMarker(selected);
			selected = undefined;
		});

		$(".caravana-locations li[data-pin=" + box.data('pin') + ']').data('marker', pin);
	}


	function selectMarker(){
//		console.log("click", this.data.id);
		if(selected)
			if(selected.notClustered && this != selected) {
				selected.infobox.close();
				markerManager.addMarker(selected);
				delete selected.notClustered;
			}
		for (var i = 0, mark; mark = markers[i]; i++) { //just a dblcheck, should never find one
			if(mark != this)
				mark.infobox.close();
		}
		map.panTo(this.getPosition()); //zoomToMarker();
		//map.setZoom(9);
		selected = this;
		selected.infobox.open(map, selected);
	}


	this.reset();
}
